import has from 'lodash/has';
import { VisualizationType, VisualizationTypeOption, EditableComponent } from '../models';
import { TimeSeries } from './timeSeries';
import { CategoricalBar } from './categoricalBar';
import { StatusCardGroup } from './statusCardGroup';
import { HeatGrid } from './heatGrid';
import { RatioBar } from './ratioBar';
import { Other } from './other';

export interface VisualizationTypeStrategy {
  getEditableComponent: () => EditableComponent;
}

class VisualizationTypeContext {
  private visualizationTypeStrategy: VisualizationTypeStrategy;

  constructor(visualizationTypeStrategy: VisualizationTypeStrategy) {
    this.visualizationTypeStrategy = visualizationTypeStrategy;
  }

  public getEditableComponent(): EditableComponent {
    return this.visualizationTypeStrategy.getEditableComponent();
  }
}

export class VisualizationStrategy {
  public static VISUALIZATION_TYPE_STRATEGY_MAP = {
    /* Time Series */
    [VisualizationType.TIME_SERIES as VisualizationTypeOption]: TimeSeries,

    /* Categorical */
    [VisualizationType.CATEGORICAL_BAR as VisualizationTypeOption]: CategoricalBar,

    [VisualizationType.STATUS_CARD_GROUP as VisualizationTypeOption]: StatusCardGroup,

    [VisualizationType.HEAT_GRID as VisualizationTypeOption]: HeatGrid,

    [VisualizationType.RATIO_BAR as VisualizationTypeOption]: RatioBar,

    // Non-editable visualizations
    [VisualizationType.OTHER as VisualizationTypeOption]: Other,
  };

  static getEditableComponent(visualizationType: VisualizationTypeOption): EditableComponent {
    if (has(VisualizationStrategy.VISUALIZATION_TYPE_STRATEGY_MAP, visualizationType)) {
      const visualizationTypeStrategy = new VisualizationStrategy.VISUALIZATION_TYPE_STRATEGY_MAP[
        visualizationType
      ]() as VisualizationTypeStrategy;
      const visualizationTypeContext = new VisualizationTypeContext(visualizationTypeStrategy);
      return visualizationTypeContext.getEditableComponent();
    }

    return new VisualizationTypeContext(
      new VisualizationStrategy.VISUALIZATION_TYPE_STRATEGY_MAP[VisualizationType.TIME_SERIES](),
    ).getEditableComponent();
  }
}
